let headerTop = document.querySelector('.header-top'),
	headerCenter = document.querySelector('.header-center'),
	headerBottom = document.querySelector('.header-bottom');

$('.vg-nav .dropdown').hover(function () {
	if (document.body.classList.contains('hovered')) {
		document.body.style.paddingRight = "";
		document.body.style.overflow = "";
		document.body.classList.remove('hovered');

		if (headerBottom) headerBottom.style.paddingRight = '';
		if (headerCenter) headerCenter.style.paddingRight = '';
		if (headerTop) headerTop.style.paddingRight = '';
	} else {
		let indent = (window.innerWidth - document.documentElement.clientWidth) + 'px';
		document.body.style.paddingRight = indent;
		document.body.style.overflow = "hidden";
		document.body.classList.add('hovered');

		if (headerBottom) headerBottom.style.paddingRight = indent;
		if (headerCenter) headerCenter.style.paddingRight = indent;
		if (headerTop) headerTop.style.paddingRight = indent;
	}
});
